import { useId } from "react";
import {
  FROST_CRYSTALS,
  GardenGround,
  SkySvgShell,
  VIEW_HEIGHT,
  VIEW_WIDTH,
} from "@/app/components/weather/backgrounds/shared";

/**
 * FrostSky — pale cool sky with soft cloud cover and frost crystal motifs.
 * Full-viewport illustration; garden silhouettes anchor to the bottom edge.
 */
export function FrostSky() {
  const uid = useId().replace(/:/g, "");
  const sky = `${uid}-sky`;
  const haze = `${uid}-haze`;

  return (
    <SkySvgShell>
      <defs>
        <linearGradient id={sky} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#B8D0E8" />
          <stop offset="35%" stopColor="#C8DCE8" />
          <stop offset="70%" stopColor="#D8E8F0" />
          <stop offset="100%" stopColor="#E8F0F8" />
        </linearGradient>
        <linearGradient id={haze} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#E8F0F8" stopOpacity="0" />
          <stop offset="100%" stopColor="#D0E0EC" stopOpacity="0.9" />
        </linearGradient>
      </defs>

      <rect width={VIEW_WIDTH} height={VIEW_HEIGHT} fill={`url(#${sky})`} />

      <g fill="#E8F0F8" opacity="0.8">
        <ellipse cx="80" cy="70" rx="70" ry="25" />
        <ellipse cx="40" cy="65" rx="36" ry="18" />
        <ellipse cx="200" cy="80" rx="80" ry="28" />
        <ellipse cx="320" cy="75" rx="65" ry="24" />
      </g>

      <g fill="#F0F6FC" opacity="0.9">
        <ellipse cx="100" cy="110" rx="90" ry="32" />
        <ellipse cx="260" cy="105" rx="85" ry="30" />
        <ellipse cx="360" cy="115" rx="55" ry="26" />
      </g>

      <g stroke="#C8D8E8" strokeWidth="1.2" fill="none" opacity="0.65">
        {FROST_CRYSTALS.map(([x, y], i) => (
          <g key={i} transform={`translate(${x},${y})`}>
            <path d="M 0 -7 L 0 7 M -7 0 L 7 0 M -5 -5 L 5 5 M -5 5 L 5 -5" />
          </g>
        ))}
      </g>

      <rect x="0" y="180" width={VIEW_WIDTH} height={VIEW_HEIGHT - 180} fill={`url(#${haze})`} />

      <GardenGround fill="#182838" />
    </SkySvgShell>
  );
}
